export default __webpack_public_path__ + "bin-file/rounded-arrow.svg";